import React, { useState, useEffect } from 'react'
import MainLayout from '../layout/MainLayout'
import SearchTile from '../components/SearchTile';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';



function SearchResultsList(props) {


    const [searchParams] = useSearchParams();
    const queryText = String(searchParams.get("qry_txt") ? searchParams.get("qry_txt") : "");

    const [documentList, setResults] = useState([]);
    const getResults = async () => {
        let url = "/api/v1/search/query?qry_txt=" + queryText;
        axios
            .get(url)
            .then((result) => {
                setResults(result.data);
            }
            )
            .catch((err) => console.log(err));
    }




    useEffect(() => {
        getResults();
    }, []);


    const formatText = (text) => {
        if (!text) return "";

        // Replace **bold** text
        let formatted = text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong><br/>");

        // Add indentation for lines starting with *
        formatted = formatted.replace(
            /(^|\n)\*(.*)/g,
            '$1<span style="margin-left: 2em; display: block;">$2</span>'
        );

        // Indent lines starting with numbers like 1., 2), 3:
        formatted = formatted.replace(
            /(^|\n)\d+[.):](.*)/g,
            '$1<span style="margin-left: 2em; display: block;">$&</span>'
        );

        // Replace newlines with <br/>
        //formatted = formatted.replace(/\n\n/g, "\n");
        formatted = formatted.replace(/\n/g, "<br/>");

        return formatted;
    };


    return (
        <div>
            <MainLayout>
                <h1>Search Results</h1>
                <h3>Search: {queryText}</h3>

                <h3>{documentList.length} documents</h3>


                {documentList.map((pDoc, index) => (
                    <SearchTile key={pDoc.documentId} {...pDoc}></SearchTile>
                ))}

                <br />



            </MainLayout>
        </div >
    )
}

export default SearchResultsList;
